module.exports = __webpack_public_path__ + "static/media/hero_image_bottom.e9ceee0f.svg";